import React, { useEffect, useContext, cloneElement, useState } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router';
import { Grid, Button, Typography, CircularProgress } from '@mui/material';
import CateringContext from '../CateringContext';
import AddOrEditBasicEventInfo from './CateringEvent/Components/AddOrEditBasicEventInfo';
import Utils from '../../utils/Utils';
import { RestauInfoContext } from '../../home/RestauInfoContext';

function CateringContent({ children }) {
    const {
        displayTitle,
        setDisplayTitle,
        newEventPage,
        setNewEventPage,
        setCateringDashboardPage,
        cateringDashboardPage,
        updateForm,
        setEventOrder,
        setConversation,
        setLoading,
        clearAll,
        retrieveEventsByInquiryId,
        processConversationData,
        loadingSummaryData,
        setLoadingSummaryData,
        formConfig,
        form,
        createEvent,
        renderField,
    } = useContext(CateringContext);

    const [openNewEventDialog, setOpenNewEventDialog] = useState(false);
    const [errors, setErrors] = useState({});

    const { restauHook } = useContext(RestauInfoContext);

    const navigate = useNavigate();
    const location = useLocation();
    const { RestauId, CateringInquiryId } = useParams();

    const updateTitleAndEventData = async () => {
        setCateringDashboardPage(false);
        setNewEventPage(false);
        if (
            location.pathname.endsWith('/dashboard') ||
            location.pathname.endsWith('/catering')
            //|| location.pathname.endsWith('/catering/setting')
        ) {
            clearAll();
            setCateringDashboardPage(true);
            setDisplayTitle('Dashboard');
        } else if (location.pathname.endsWith('/search')) {
            clearAll();
            setDisplayTitle('Search Catering Events');
        } else if (location.pathname.endsWith('/newevent')) {
            clearAll();
            setNewEventPage(true);
            setDisplayTitle('New Event');
        } else if (location.pathname.endsWith('/setting')) {
            clearAll();
            //setDisplayTitle('Catering Inquiry Form Settings');
            setDisplayTitle('Settings');
        } else if (location.pathname.endsWith('/dashboardSetting')) {
            clearAll();
            setDisplayTitle('Catering Dashboard Settings');
        } else if (location.pathname.endsWith('/search')) {
            clearAll();
            setDisplayTitle('Catering Inquiry Search');
        } else {
            // fetch event name with CateringInquiryId and setDisplayTitle
            //await fetchAndLoadEventData(RestauId, CateringInquiryId);
        }
    };

    const fetchAndLoadEventData = async (RestauId, CateringInquiryId) => {
        setLoading(true);
        setNewEventPage(false);
        try {
            // if (!RestauId) {
            //     //Ideally this should never happen
            //     RestauId = restauHook.restauId;
            // }
            let response = await retrieveEventsByInquiryId(
                RestauId,
                CateringInquiryId
            );
            //debugger;
            let { inquiryData } = response.data;
            let eventData = inquiryData.events && inquiryData.events[0];
            if (inquiryData.conversationData) {
                if (inquiryData.conversationData.conversation) {
                    setConversation(inquiryData.conversationData.conversation);
                } else {
                    setConversation(inquiryData.conversationData);
                }

                //if there is no summary data, then this conversation has not ended or failed to end.
                //Try to summarize the conversation with ai now
                if (
                    !inquiryData.conversationData.summary
                    //|| !inquiryData.conversationData.summary.eventDate
                ) {
                    setLoadingSummaryData(true);
                    response = await processConversationData(
                        RestauId,
                        CateringInquiryId
                    );
                    if (response.data) {
                        if (
                            response.data.status &&
                            response.data.status === true
                        ) {
                            //processed and fetched the inquiry data again.
                            console.log(
                                'Summarized Inquiry data: ',
                                response.data.inquiryData
                            );
                            eventData = response.data.inquiryData;
                        } else {
                            //failed to summarize the conversation data
                            console.log(
                                'Failed to summarize the conversation data.'
                            );
                        }
                    }
                    setLoadingSummaryData(false);
                }
            } else setConversation(null);
            // To update later for multiple events under the same inquiryId
            const { orders, ...formData } = eventData;
            if (orders) {
                setEventOrder(orders);
            } else {
                setEventOrder(null);
            }
            updateForm(formData);
            let eventTitle = eventData.eventName
                ? eventData.eventName
                : (eventData.customerName
                      ? eventData.customerName
                      : 'No Name') + "'s Event";
            setDisplayTitle(eventTitle);
        } catch (error) {
            console.log('Error fetching event: ', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        updateTitleAndEventData();
    }, [location.pathname]);

    // Handle saving new event from dialog
    const handleSaveNewEvent = async (e) => {
        form.eventStatus = 'New Event';
        setErrors({});
        let tempErrors = {};

        if (!form.customerName || form.customerName.length === 0)
            tempErrors['customerName'] = 'Please fill out the customer';

        if (!form.email || form.email.length === 0)
            tempErrors['email'] = 'Please fill out the email.';
        else if (form.email.length !== 0) {
            const emailReg = /\S+@\S+\.\S+/;
            if (!emailReg.test(form.email))
                tempErrors['email'] = 'Please enter a valid email';
        }

        if (!form.phone || form.phone.length === 0)
            tempErrors['phone'] = 'Please fill out the phone number.';
        else if (form.phone.length !== 0) {
            let formattedPhNum = Utils.getPhoneNumberInE164Format(form.phone);
            updateForm({ ...form, phone: formattedPhNum });
            form.phone = formattedPhNum;
            if (formattedPhNum.length !== 12) {
                tempErrors['phone'] = 'Please enter a valid phone number';
            }
        }

        if (!form.numOfGuests || form.numOfGuests.length === 0)
            tempErrors['numOfGuests'] = 'Please fill out this field';
        else if (isNaN(Number(form.numOfGuests))) {
            tempErrors['numOfGuests'] =
                'Please provide a valid number for Number of Guests';
        }

        if (!form.eventStatus)
            tempErrors['eventStatus'] = 'Please select a status for the event';

        setErrors(tempErrors);

        if (Object.keys(tempErrors).length === 0) {
            try {
                setLoading(true);
                e && e.preventDefault();
                const response = await createEvent(form);
                const { createdInquiry } = await response.data;
                setOpenNewEventDialog(false);
                navigate(
                    `/catering/${createdInquiry.restauId}/${createdInquiry.inquiryId}`
                );
            } catch (error) {
                console.log('Error creating new event: ', error);
                alert('Error creating event. Please try again.');
            } finally {
                setLoading(false);
            }
        } else {
            throw new Error(Object.values(tempErrors).join(' '));
        }
    };

    return (
        <Grid container direction="column">
            <Grid
                item
                xs={12}
                sx={(theme) => ({
                    [theme.breakpoints.up('sm')]: {
                        justifyContent: 'space-between',
                        display: 'flex',
                        alignItems: 'center',
                    },
                })}
            >
                <Grid item>
                    <Typography component="h2" variant="h5">
                        {displayTitle}
                    </Typography>
                    {loadingSummaryData && (
                        <Typography variant="h6">
                            Fetching Summary data
                            <CircularProgress
                                size={12}
                                sx={{ ml: 0.5, color: 'black' }}
                            />
                        </Typography>
                    )}
                </Grid>
                <Grid item justifyContent={'flex-end'}>
                    <>
                        {!cateringDashboardPage && (
                            <Button
                                size="small"
                                variant="outlined"
                                style={{ marginRight: 8 }}
                                onClick={() => navigate('/catering/dashboard')}
                            >
                                Back
                            </Button>
                        )}
                        {!newEventPage && (
                            <Button
                                size="small"
                                variant="contained"
                                onClick={() => {
                                    clearAll(); // Clear any existing form data
                                    setOpenNewEventDialog(true);
                                }}
                            >
                                Create New Event
                            </Button>
                        )}
                    </>
                </Grid>
            </Grid>
            <Grid item xs={12}>
                {cloneElement(children, {
                    loadingSummaryData,
                    setLoadingSummaryData,
                })}
            </Grid>

            {/* New Event Dialog */}
            {formConfig && (
                <AddOrEditBasicEventInfo
                    openEditDialog={openNewEventDialog}
                    setOpenEditDialog={setOpenNewEventDialog}
                    formConfig={formConfig}
                    form={form || {}}
                    renderField={(field) => renderField(field, errors)}
                    updateExistingEvent={handleSaveNewEvent}
                />
            )}
        </Grid>
    );
}

export default CateringContent;
